import { useState } from "react";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

const fieldCls = "bg-slate-900 border-slate-700 text-slate-100 h-10";
const labelCls = "text-xs uppercase tracking-[0.18em] text-slate-400 font-mono";
const empty = { current: "", next: "", confirm: "" };

export const ProfileDialog = ({ open, onOpenChange, user }) => {
  const [form, setForm] = useState(empty);
  const [saving, setSaving] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (form.next !== form.confirm) return toast.error("Le nuove password non coincidono");
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: form.current, new_password: form.next });
      toast.success("Password aggiornata");
      setForm(empty);
      onOpenChange(false);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent aria-describedby={undefined} className="bg-[#111827] border-slate-700 text-slate-100 sm:max-w-md" data-testid="profile-dialog">
        <DialogHeader><DialogTitle className="font-display text-2xl">Il mio profilo</DialogTitle></DialogHeader>
        <div className="rounded-lg border border-slate-700/70 bg-slate-900/50 p-4">
          <p className="text-sm text-slate-100" data-testid="profile-name">{user.name}</p>
          <p className="font-mono text-xs text-slate-400" data-testid="profile-email">{user.email}</p>
        </div>
        <form onSubmit={submit} className="space-y-3" data-testid="change-password-form">
          <p className={`${labelCls} flex items-center gap-2`}><KeyRound className="w-3.5 h-3.5" /> Cambia password</p>
          <Input required type="password" placeholder="Password attuale" value={form.current} onChange={set("current")} className={fieldCls} data-testid="current-password-input" />
          <Input required type="password" minLength={8} placeholder="Nuova password (min 8)" value={form.next} onChange={set("next")} className={fieldCls} data-testid="new-password-input" />
          <Input required type="password" minLength={8} placeholder="Conferma nuova password" value={form.confirm} onChange={set("confirm")} className={fieldCls} data-testid="confirm-password-input" />
          <Button disabled={saving} className="w-full bg-blue-600 hover:bg-blue-700 text-white" data-testid="change-password-submit-button">
            {saving ? "Salvataggio…" : "Aggiorna password"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
